import { render, staticRenderFns } from "./batch-get-patient-benefits-action-output.vue?vue&type=template&id=00238a54&scoped=true"
import script from "./batch-get-patient-benefits-action-output.vue?vue&type=script&lang=js"
export * from "./batch-get-patient-benefits-action-output.vue?vue&type=script&lang=js"
import style0 from "./batch-get-patient-benefits-action-output.vue?vue&type=style&index=0&id=00238a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00238a54",
  null
  
)

export default component.exports